import { useEffect } from 'react'
import { useBanner } from 'containers/Banner'

import { useGetWorkspaceUploadsRestrictedForQuery } from '@sketch/gql-types'

interface RestrictedWorkspaceBannerManagerProps {
  workspaceId: string
}

const BANNER_ID = 'restricted-workspace'
// Types
declare module 'containers/Banner/BannersMap.types' {
  export interface BannersMap {
    'restricted-workspace': null
  }
}

const BANNER_TEXT =
  'Uploading, renaming and editing documents are not available for Editors ' +
  'because document uploads are restricted in this Workspace.'

export const RestrictedWorkspaceBannerManager = (
  props: RestrictedWorkspaceBannerManagerProps
) => {
  const { workspaceId } = props
  const { showBanner, dismissBanner: globalDismissBanner } = useBanner()

  const uploadsRestrictedForResult = useGetWorkspaceUploadsRestrictedForQuery({
    variables: { identifier: workspaceId },
    shouldInvalidatePrevious: (prev, curr) =>
      prev?.identifier !== curr?.identifier,
  })

  useEffect(() => {
    const uploadsRestrictedFor =
      uploadsRestrictedForResult.data?.workspace?.uploadsRestrictedFor ?? 'NONE'

    if (uploadsRestrictedFor === 'SELF') {
      const { dismissBanner } = showBanner({
        id: BANNER_ID,
        type: 'information',
        message: BANNER_TEXT,
      })

      return () => {
        dismissBanner()
      }
    } else {
      globalDismissBanner(BANNER_ID)
    }
  }, [showBanner, uploadsRestrictedForResult, globalDismissBanner])

  return null
}
